import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=14c9132c&"
import script from "./SendMessageDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SendMessageDialog.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports